import { Building2, Warehouse, Users, Route, Package, Store, Tag, Eraser, DatabaseBackup, PackageOpen, Settings } from "lucide-react";

// Order is the order shown; `permission` (one or a list, any of them) comes from GET /auth/me.
export const ADMIN_TABS = [
  { tab: "tenants",    permission: "tenants:manage",          icon: Building2 },
  { tab: "warehouses", permission: "warehouses:manage",       icon: Warehouse },
  { tab: "users",      permission: "users:manage",            icon: Users },
  { tab: "route",      permission: "route_profiles:view",     icon: Route },
  { tab: "products",   permission: ["products:create", "products:manage"], icon: Package },
  { tab: "stores",     permission: "stores:manage",           icon: Store },
  { tab: "fnsku",      permission: "stores:manage",           icon: Tag },
  { tab: "inbound",    permission: "tenants:manage",          icon: PackageOpen }, // platform admin, read only
  { tab: "testdata",   permission: "test_data:manage",        icon: Eraser },
  { tab: "dbbackup",   permission: "db_backup:manage",        icon: DatabaseBackup },
  { tab: "settings",   permission: "tenants:manage",          icon: Settings },     // platform admin
];

export function visibleAdminTabs(user) {
  const permissions = user?.permissions || [];
  return ADMIN_TABS.filter(item => [].concat(item.permission).some(p => permissions.includes(p)));
}

export function can(user, permission) {
  return Boolean(user?.permissions?.includes(permission));
}
